module.exports = __webpack_public_path__ + "static/Navigation.674001f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Navigation.jpg
// module id = 401
// module chunks = 65579394461380